const typography = {
  valid: {
    variants: ['h1', 'h3', 'h5', 'lead', 'paragraph', 'small'] as const,
  },
  styles: {
    variants: {
      h1: {
        fontFamily: 'font-barlow',
        fontSize: 'text-5xl',
        lineHeight: 'leading-none',
        color: 'dark:text-base-gray-400',
      },
      h2: {
        color: 'dark:text-base-gray-400',
      },
      h3: {
        fontFamily: 'font-barlow',
        fontSize: 'text-2xl',
        lineHeight: 'leading-none',
        color: 'dark:text-base-gray-500',
      },
      h4: {
        color: 'dark:text-base-gray-500',
      },
      h5: {
        fontSize: 'text-[1.25rem]',
        color: 'dark:text-base-gray-500',
      },
      lead: {
        fontFamily: 'font-barlow',
        fontSize: 'text-4xl',
        lineHeight: 'leading-none',
        color: 'dark:text-base-gray-400',
      },
      paragraph: {
        fontSize: 'text-base',
        color: 'dark:text-base-gray-500',
      },
      small: {
        fontSize: 'text-[0.685rem]',
        color: 'dark:text-base-gray-500',
      },
    },
  },
}

const button = {
  defaultProps: {
    variant: 'filled' as const,
    size: 'md' as const,
    color: 'accent' as const,
    fullWidth: false,
    ripple: true,
    className: 'focus:ring-0',
  },
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    base: {
      initial: {
        textTransform: '',
      },
    },
    sizes: {
      md: {
        fontSize: 'text-[0.812rem]',
        py: 'py-3',
        px: 'px-10',
        borderRadius: 'rounded-lg',
      },
      sm: {
        fontSize: 'text-[0.812rem]',
        py: 'py-1',
        px: 'px-4',
        borderRadius: 'rounded-lg',
      },
    },
    variants: {
      filled: {
        primary: {
          backgroud: 'bg-primary-500 text-white dark:bg-primary-600 dark:text-white',
          color: 'text-white',
          shadow: 'shadow-md shadow-primary-500/20 dark:shadow-primary-600/20',
          hover: 'hover:shadow-lg hover:shadow-primary-500/40 dark:hover:shadow-primary-600/40',
          focus: 'focus:opacity-[0.85] focus:shadow-none',
          active: 'active:opacity-[0.85] active:shadow-none',
        },
        accent: {
          backgroud: 'bg-accent-500 text-primary',
          color: 'text-primary',
          shadow: 'shadow-md shadow-accent-500/20',
          hover: 'hover:shadow-lg hover:shadow-accent-500/40',
          focus: 'focus:opacity-[0.85] focus:shadow-none',
          active: 'active:opacity-[0.85] active:shadow-none',
        },
        red: {
          backgroud: 'bg-accent-red-500',
          color: 'text-white',
          shadow: 'shadow-md shadow-accent-red-500/20',
          hover: 'hover:shadow-lg hover:shadow-accent-red-500/40',
          focus: 'focus:opacity-[0.85] focus:shadow-none',
          active: 'active:opacity-[0.85] active:shadow-none',
        },
      },
      gradiend: {
        red: {
          backgroud: 'bg-gradient-to-tr from-accent-red-600 to-accent-red-400',
          color: 'text-white',
          shadow: 'shadow-md shadow-accent-red-500/20',
          hover: 'hover:shadow-lg hover:shadow-accent-red-500/40',
          active: 'active:opacity-[0.85]',
        },
      },
      outlined: {
        primary: {
          border: 'border border-primary-500',
          color: 'text-primary-500',
          hover: 'hover:opacity-75',
          focus: 'focus:ring focus:primary-200',
          active: 'active:opacity-[0.85]',
        },
        accent: {
          border: 'border border-accent-500',
          color: 'text-accent-500',
          hover: 'hover:opacity-75',
          focus: 'focus:ring-0',
          active: 'active:opacity-[0.85]',
        },
        red: {
          border: 'border border-accent-red-500',
          color: 'text-accent-red-500',
          hover: 'hover:opacity-75',
          focus: 'focus:ring focus:ring-accent-red-200',
          active: 'active:opacity-[0.85]',
        },
      },
      text: {
        primary: {
          color: 'text-primary opacity-100',
          hover: 'hover:bg-primary-500/10',
          active: 'active:bg-primary-500/30',
        },
        accent: {
          color: 'text-accent opacity-100',
          hover: 'hover:bg-accent-500/10',
          active: 'active:bg-accent-500/30',
        },
        red: {
          color: 'text-accent-red-500',
          hover: 'hover:bg-accent-red-500/10',
          active: 'active:bg-accent-red-500/30',
        },
      },
    },
  },
}

const iconButton = {
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    variants: {
      filled: {
        primary: {
          backgroud: 'bg-primary-500 dark:text-white',
          color: 'text-white-yellow-500',
          shadow: 'shadow-md shadow-primary-500/10',
          hover: 'hover:shadow-lg hover:shadow-primary-500/20',
          focus: 'focus:opacity-[0.85] focus:shadow-none',
          active: 'active:opacity-[0.85] active:shadow-none',
        },
        accent: {
          backgroud: 'bg-accent-500',
          color: 'text-primary-500',
          shadow: 'shadow-md shadow-accent-500/10',
          hover: 'hover:shadow-lg hover:shadow-accent-500/20',
          focus: 'focus:opacity-[0.85] focus:shadow-none',
          active: 'active:opacity-[0.85] active:shadow-none',
        },
      },
      gradient: {
        primary: {
          backgroud: 'bg-gradient-to-tr from-primary-600 to-primary-400',
          color: 'text-white-yellow-500',
          shadow: 'shadow-md shadow-primary-500/20',
          hover: 'hover:shadow-lg hover:shadow-primary-500/40',
          active: 'active:opacity-[0.85]',
        },
        accent: {
          backgroud: 'bg-gradient-to-tr from-accent-600 to-accent-400',
          color: 'text-primary-500',
          shadow: 'shadow-md shadow-accent-500/20',
          hover: 'hover:shadow-lg hover:shadow-accent-500/40',
          active: 'active:opacity-[0.85]',
        },
      },
      outlined: {
        primary: {
          border: 'border border-primary-500',
          color: 'text-primary-500',
          hover: 'hover:opacity-60',
          focus: 'focus:ring focus:ring-primary-500',
          active: 'active:opacity-[0.85]',
        },
        accent: {
          border: 'border border-accent-500',
          color: 'text-accent-500',
          hover: 'hover:opacity-50',
          focus: 'focus:ring focus:ring-accent-200',
          active: 'active:opacity-[0.85]',
        },
      },
      text: {
        primary: {
          color: 'text-primary-500 dark:text-white',
          hover: 'hover:bg-primary-500/10 dark:text-white-500/10',
          active: 'active:bg-primary-500/30 dark:text-white-500/30',
        },
        accent: {
          color: 'text-accent-500 dark:text-white',
          hover: 'hover:bg-accent-500/10 dark:text-white-500/10',
          active: 'active:bg-accent-500/30 dark:text-white-500/30',
        },
      },
    },
  },
}

const input = {
  defaultProps: {
    variant: 'outlined' as const,
    size: 'md' as const,
  },
  styles: {
    base: {
      input: {
        color: 'text-gray-900 dark:text-white',
        borderWidth: 'placeholder-shown:border ',
        borderColor: 'border-gray-500 placeholder-shown:border-gray-500',
      },
    },
    variants: {
      outlined: {
        base: {
          input: {
            color: 'inherit',
            borderWidth: 'placeholder-shown:border',
            borderColor: 'border-gray-500 placeholder-shown:border-gray-500',
          },
        },
      },
    },
  },
}

const card = {
  defaultProps: {
    className: 'bg-white dark:bg-primary-500',
  },
  styles: {
    base: {
      initial: {
        color: 'dark:base-gray-400',
        borderRadius: 'rounded-md',
        display: 'flex',
        flexDirection: 'flex-row items-center',
      },
    },
  },
}

const cardHeader = {
  defaultProps: {
    floated: false,
    className: 'flex-shrink-0',
  },
  styles: {
    base: {
      initial: {
        mt: 'mt-0',
        mx: 'mx-0',
      },
    },
  },
}

const cardBody = {
  defaultProps: {
    className: 'rounded-md p-4 h-fit flex-1',
  },
}

const progress = {
  valid: {
    colors: ['primary'] as const,
  },
  styles: {
    variants: {
      filled: {
        primary: {
          backgroud: 'bg-primary',
          color: 'text-white',
        },
      },
      gradient: {
        primary: {
          backgroud: 'bg-gradient-to-tr from-primary-600 to-primary-400',
          color: 'text-white',
        },
      },
    },
  },
}

const switchTheme = {
  defaultProps: {
    color: 'primary' as const,
  },
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    base: {
      label: {
        color: 'dark:text-base-gray-400',
      },
    },
    colors: {
      primary: {
        input: 'checked:bg-primary-400',
        circle: 'peer-checked:border-primary-500',
        before: 'peer-checked:before:bg-primary-500',
      },
      accent: {
        input: 'checked:bg-accent-600',
        circle: 'peer-checked:border-accent-100 peer-checked:bg-accent-100',
        before: 'peer-checked:before:bg-accent-100',
      },
    },
  },
}

const radio = {
  defaultProps: {
    color: 'primary' as const,
  },
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    colors: {
      primary: {
        color: 'text-primary-500 dark:text-gray-200',
        border: 'checked:border-primary-500 dark:border-gray-200',
        before: 'checked:before:bg-primary-500',
      },
      accent: {
        color: 'text-accent-500',
        border: 'checked:border-accent-500',
        before: 'checked:before:bg-accent-500',
      },
    },
  },
}

const spinner = {
  defaultProps: {
    color: 'primary' as const,
  },
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    colors: {
      primary: {
        color: 'text-primary-500',
      },
      accent: {
        color: 'text-accent-500',
      },
    },
  },
}

const chip = {
  defaultProps: {
    color: 'primary' as const,
    variant: 'filled' as const,
  },
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    variants: {
      filled: {
        primary: {
          backgroud: 'bg-primary-500',
          color: 'text-white',
        },
        accent: {
          backgroud: 'bg-accent-500',
          color: 'text-primary',
        },
      },
      gradient: {
        primary: {
          backgroud: 'bg-gradient-to-tr from-primary-700 to-primary-300',
          color: 'text-white',
        },
        accent: {
          backgroud: 'bg-gradient-to-tr from-accent-600 to-accent-400',
          color: 'text-primary',
        },
      },
      outlined: {
        primary: {
          border: 'border border-primary-500',
          color: 'text-primary-700',
        },
        accent: {
          border: 'border border-accent-500',
          color: 'text-accent-700',
        },
      },
      ghost: {
        primary: {
          backgroud: 'bg-primary-500/20 dark:bg-primary-500',
          color: 'text-primary-900 dark:text-white',
        },
        accent: {
          backgroud: 'bg-accent-500/20 dark:bg-accent-500',
          color: 'text-accent-800 dark:text-white',
        },
      },
    },
  },
}

const dialog = {
  styles: {
    base: {
      backdrop: {
        backgroundColor: 'bg-primary',
        backgroundOpacity: 'bg-opacity-70',
        backdropFilter: 'none',
      },
      container: {
        fontFamily: 'font-barlow',
        bg: 'bg-white dark:bg-primary-400',
      },
    },
  },
}

const dialogHeader = {
  styles: {
    base: {
      fontFamily: 'font-barlow',
      color: 'text-primary dark:text-base-gray-500',
    },
  },
}

const dialogBody = {
  styles: {
    base: {
      initial: {
        fontFamily: 'font-barlow',
      },
    },
  },
}

const dialogFooter = {
  styles: {
    base: {
      fontFamily: 'font-barlow',
    },
  },
}

const checkbox = {
  defaultProps: {
    color: 'primary' as const,
  },
  valid: {
    colors: ['primary', 'accent'] as const,
  },
  styles: {
    colors: {
      primary: {
        background: 'checked:bg-primary-500',
        border: 'checked:border-primary-500',
        before: 'checked:before:bg-primary-500',
      },
      accent: {
        background: 'checked:bg-accent-500',
        border: 'checked:border-accent-500',
        before: 'checked:before:bg-accent-500',
      },
    },
  },
}

const tooltip = {
  styles: {
    base: {
      zIndex: 'z-[9999]',
    },
  },
}

export const customTheme = {
  typography,
  button,
  iconButton,
  input,
  card,
  cardHeader,
  cardBody,
  switch: switchTheme,
  progress,
  radio,
  spinner,
  chip,
  dialog,
  dialogHeader,
  dialogBody,
  dialogFooter,
  checkbox,
  tooltip,
}
